<template>
    <div style="margin-top:-20px">
        <div style="position:fixed;background:#fff;width:100%;z-index:10">
            <el-tabs v-model="activeName" @tab-click="handleClick" >
                <el-tab-pane label="个人资料信息" name="Customer_detail_person"></el-tab-pane>
                <el-tab-pane label="认证信息" name="Customer_detail_company"></el-tab-pane>
            </el-tabs>
        </div>
        
        <router-view style="padding-top:100px"></router-view>
    </div>
</template>
<script>
  export default {
    data() {
      return {
        id:'',
        activeName: 'Customer_detail_person'
      };
    },
    methods: {
      handleClick(tab, event) {
        this.$router.push({name:this.activeName,query:{id:this.id}})
      }
    },
    mounted() {
        this.id=this.$route.query.id;
        this.$router.push({name:this.activeName,query:{id:this.id}})
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/customer/customer_detail.vue